import { render, staticRenderFns } from "./couponDetail.vue?vue&type=template&id=50335870&scoped=true&"
import script from "./couponDetail.vue?vue&type=script&lang=js&"
export * from "./couponDetail.vue?vue&type=script&lang=js&"
import style0 from "./couponDetail.vue?vue&type=style&index=0&id=50335870&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50335870",
  null
  
)

export default component.exports